export default {
  Commitment: {
    title: 'Rating commitment',
    desc: 'Please sign in the gray area below',
    reset: 'reset',
    confirm: 'Confirm',
  },
  Interviewer: {
    signIn: 'Check-in',
    photoSignIn: 'Check-in',
    complete: 'complete',
    rePhoto: 'rephoto',
    capture: 'Capture',
    cancel: 'Cancel',
    confirmUpload: 'Confirm',
  },
  ResultTable: {
    average: 'average score',
    max: 'The highest score',
    min: 'lowest score',
    sequence: 'number',
    name: 'name',
    gender: 'gender',
    score: 'score',
    interviewing: 'In progress',
  },
  ScoreTab: {
    score: 'Point',
    half: 'Half score',
    all: 'Full score',
    already: 'Scored',
    comment: 'Comment',
  },
  StuViewer: {
    signIn: 'candidate signin',
    photoSignIn: 'Check-in',
    upload: 'Upload the file',
    success: 'The authentication passed.',
    fail: 'The authentication failed!',
    confirm: 'Confirm',
    complete: 'complete',
    rePhoto: 'rephoto',
  },
};
